module.exports = __webpack_public_path__ + "src/img/artist/work09_1.jpg?62ff221999668d2f795d440467c50a84";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work09_1.jpg
// module id = 26
// module chunks = 0